import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useClientTabFocus } from './clientTabFocusContext'
import { ClientTabRequirementsContext } from './clientTabRequirementsContext'
import { CONSUMPTION_FIELD_COUNT } from './clientTabStatus'

export type ChipTone = 'ok' | 'warn' | 'neutral'

export interface StatusChipData {
  key: string
  text: string
  tone: ChipTone
  onClick: () => void
}

const useClientTabStatusChips = () => {
  const { t } = useTranslation()
  const { focusCard } = useClientTabFocus()
  const {
    formIsLoaded,
    zohoIsInValid,
    isValidZohoId,
    missingIdentityCount,
    missingAddressCount,
    filledConsumption,
    showConsumption,
  } = useContext(ClientTabRequirementsContext)

  const withCount = (label: string, count: number) =>
    count > 0 ? t('subscriptionForm:client_tab.chips.to_complete', { label, count }) : label

  const zohoLabel = t('subscriptionForm:zoho_module.module_title')

  const chips: StatusChipData[] = [
    {
      key: 'zoho',
      text: withCount(zohoLabel, isValidZohoId ? 0 : 1),
      tone: isValidZohoId ? 'ok' : 'warn',
      onClick: () => focusCard('ZohoModule', 'ZohoModule'),
    },
    {
      key: 'identity',
      text: withCount(t('subscriptionForm:client_tab.chips.identity'), missingIdentityCount),
      tone: missingIdentityCount > 0 ? 'warn' : 'ok',
      onClick: () =>
        zohoIsInValid ? focusCard('ZohoModule', 'ZohoModule') : focusCard('CustomerModule', 'CustomerModule'),
    },
    {
      key: 'address',
      text: withCount(t('subscriptionForm:client_tab.chips.address'), missingAddressCount),
      tone: missingAddressCount > 0 ? 'warn' : 'ok',
      onClick: () => focusCard('AddressModule', 'AddressModule'),
    },
  ]

  if (showConsumption) {
    chips.push({
      key: 'consumption',
      text: `${t('subscriptionForm:address_v2.consumption_title')} · ${filledConsumption}/${CONSUMPTION_FIELD_COUNT}`,
      tone: filledConsumption === CONSUMPTION_FIELD_COUNT ? 'ok' : 'neutral',
      onClick: () => focusCard('ConsumptionSection', 'AddressModule'),
    })
  }

  return { hidden: !formIsLoaded, chips }
}

export default useClientTabStatusChips
